'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getUserLangKey = require('./getUserLangKey');

var _getUserLangKey2 = _interopRequireDefault(_getUserLangKey);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Redirect to user language home page, from: / to: /langKey/
 * @param {[String]} langs allowed lang keys ['en', 'fr', 'pt']
 * @param {String} defaultLangKey default browser language key
 * @return {void}
 */
var redirectToHome = function redirectToHome(langs, defaultLangKey) {
  if (typeof window === 'undefined') {
    return;
  }

  var langKey = (0, _getUserLangKey2.default)(langs, defaultLangKey);
  var newUrl = '/' + langKey + '/';
  window.location.replace(newUrl);
};

exports.default = redirectToHome;


//////////////////
// WEBPACK FOOTER
// ./~/ptz-i18n/dist/redirectToHome.js
// module id = 333
// module chunks = 35783957827783 114276838955818